import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import salesIcon from "../../assets/images/dashboardimages/Icon/salesIcon.svg";
import purchaseIcon from "../../assets/images/dashboardimages/Icon/purchaseIcon.svg";
import Bank from "../../assets/images/dashboardimages/Icon/Bank.svg";
import Cash from "../../assets/images/dashboardimages/Icon/Cash.svg";
import Netprofit from "../../assets/images/dashboardimages/Icon/Netprofit.svg";
import TopeExpenses from "../../assets/images/dashboardimages/Icon/TopExpenses.svg";
import theme from "../../styles/Themecolors";

import { API, graphqlOperation } from "aws-amplify";
import { PURGE } from "redux-persist";
import { getBusinessOverViewDataCustom } from "../../graphql/customQueries";
import { useSelector } from "react-redux";

export const fetchBusinessOverviewData = createAsyncThunk(
  "dashboard/fetchBusinessOverviewData",
  async ({
    FinancialYearID,
    startDate,
    endDate,
    AccountGroupName,
    AccountTypeCD,
    DataRange,
    MonthValue,
    type,
  }) => {
    try {
      // const response = await API.graphql(
      //   graphqlOperation(getBusinessOverViewDatav2, {
      //     businessOverViewInput: {
      //       FinancialYearID,
      //       AccountGroupName,
      //       AccountTypeCD,
      //       DataRange,
      //       MonthValue,
      //     },
      //   })
      // );
      // let Data = response?.data?.getBusinessOverViewDatav2;
      // return {
      //   data: Data,
      //   startDate,
      //   endDate,
      //   DataRange,
      //   type,
      // };
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

// export const fetchNetProfit = createAsyncThunk(
//   "businessoverview/fetchnetprofit",
//   async ({ startDate, endDate }) => {
//     const response = await API.graphql(
//       graphqlOperation(listBalancesheetProfitAndLoss, {
//         StartDate: startDate,
//         EndDate: endDate,
//       })
//     );
//     let data = response?.data?.listBalancesheetProfitAndLoss[0];
//     if (data) {
//       return {
//         value: data?.NetLoss !== 0 ? data?.NetLoss : data?.NetProfit,
//       };
//     }
//   }
// );

const INITIAL_STATE = {
  cards: {
    sales: {
      id: "sales",
      label: "Sales",
      AccountGroupName: "Sales",
      AccountTypeCD: "PandL",
      timeFrame: "This financial Year",
      value: 0,
      icon: salesIcon,
      color: "blue",
      initialData: [],
      compareGraphData: {
        data1: [],
        data2: [],
      },
      details: {
        today: {
          id: "today",
          label: "Today",
          value: 0,
          color: theme.palette.background.tablebg,
        },
        thisWeek: {
          id: "thisWeek",
          label: "This Week",
          value: 0,
          color: theme.palette.background.tablebg,
        },

        thisMonth: {
          id: "thisMonth",
          label: "This Month",
          value: 0,
          color: theme.palette.background.tablebg,
        },

        thisQuarter: {
          id: "thisQuarter",
          label: "This Quarter",
          value: 0,
          color: theme.palette.background.tablebg,
        },
      },
      isLoading: false,
      render: true,
      error: "",
    },
    purchases: {
      id: "purchases",
      label: "Purchases",
      timeFrame: "This financial Year",
      AccountGroupName: "Purchases",
      AccountTypeCD: "PandL",
      value: 0,
      icon: purchaseIcon,
      color: "purple",
      initialData: [],
      compareGraphData: {
        data1: [],
        data2: [],
      },
      details: {
        today: {
          id: "today",
          label: "Today",
          value: 0,
          color: theme.palette.background.tablebg,
        },
        thisWeek: {
          id: "thisWeek",
          label: "This Week",
          value: 0,
          color: theme.palette.background.tablebg,
        },

        thisMonth: {
          id: "thisMonth",
          label: "This Month",
          value: 0,
          color: theme.palette.background.tablebg,
        },
        thisQuarter: {
          id: "thisQuarter",
          label: "This Quarter",
          value: 0,
          color: theme.palette.background.tablebg,
        },
      },
      isLoading: false,
      render: true,
      error: "",
    },
    bank: {
      id: "bank",
      label: "Cash in Bank",
      timeFrame: "Today",
      AccountGroupName: "Bank Accounts",
      AccountTypeCD: "BS",
      value: 0,
      icon: Bank,
      color: "purple",
      initialData: [],
      compareGraphData: {
        data1: [],
        data2: [],
      },
      details: {
        today: {
          id: "today",
          label: "Today",
          value: 0,
          color: theme.palette.background.tablebg,
        },
        thisWeek: {
          id: "thisWeek",
          label: "This Week",
          value: 0,
          color: theme.palette.background.tablebg,
        },

        thisMonth: {
          id: "thisMonth",
          label: "This Month",
          value: 0,
          color: theme.palette.background.tablebg,
        },
        thisQuarter: {
          id: "thisQuarter",
          label: "This Quarter",
          value: 0,
          color: theme.palette.background.tablebg,
        },
      },
      isLoading: false,
      render: true,
      error: "",
    },
    hand: {
      id: "hand",
      label: "Cash in Hand",
      timeFrame: "Today",
      AccountGroupName: "Cash in Hand",
      AccountTypeCD: "BS",
      value: 0,
      icon: Cash,
      color: "purple",
      initialData: [],
      compareGraphData: {
        data1: [],
        data2: [],
      },
      details: {
        today: {
          id: "today",
          label: "Today",
          value: 0,
          color: theme.palette.background.tablebg,
        },
        thisWeek: {
          id: "thisWeek",
          label: "This Week",
          value: 0,
          color: theme.palette.background.tablebg,
        },

        thisMonth: {
          id: "thisMonth",
          label: "This Month",
          value: 0,
          color: theme.palette.background.tablebg,
        },
        thisQuarter: {
          id: "thisQuarter",
          label: "This Quarter",
          value: 0,
          color: theme.palette.background.tablebg,
        },
      },
      isLoading: false,
      render: true,
      error: "",
    },
    netProfit: {
      id: "netProfit",
      label: "Net Profit",
      timeFrame: "This financial Year",
      AccountGroupName: "Reserves and Surplus",
      AccountTypeCD: "BS",
      value: 0,
      icon: Netprofit,
      color: "purple",
      initialData: [],
      compareGraphData: {
        data1: [],
        data2: [],
      },
      details: {
        today: {
          id: "today",
          label: "Today",
          value: 0,
          color: theme.palette.background.tablebg,
        },
        thisWeek: {
          id: "thisWeek",
          label: "This Week",
          value: 0,
          color: theme.palette.background.tablebg,
        },

        thisMonth: {
          id: "thisMonth",
          label: "This Month",
          value: 0,
          color: theme.palette.background.tablebg,
        },
        thisQuarter: {
          id: "thisQuarter",
          label: "This Quarter",
          value: 0,
          color: theme.palette.background.tablebg,
        },
      },
      isLoading: false,
      render: true,
      error: "",
    },
    topExpenses: {
      id: "topExpenses",
      label: "Top 5 Expenses",
      timeFrame: "This financial Year",
      AccountGroupName: "Reserves and Surplus",
      AccountTypeCD: "Top 5 Expenses",
      value: 0,
      icon: TopeExpenses,
      color: "purple",
      initialData: [],
      compareGraphData: {
        data1: [],
        data2: [],
      },
      details: {},
      isLoading: false,
      render: true,
      error: "",
    },
  },
  initialData: {
    this: [],
    compare: [],
  },
  monthlyData: {
    data1: [],
    data2: [],
  },
  selectedCard: "sales",
  loading: false,
  render: true,
  topExpenses: [],
  periodOptions: [
    { value: "fy", label: "This Financial Year" },
    { value: "month", label: "This Month" },
    // { value: "quarter", label: "This Quarter" },
  ],
  compareOptions: [],
  currentSelection: {
    period: "fy",
    comparison: null,
  },
  comparisonData: {},
};

function parseDate(dateString) {
  return new Date(dateString);
}

function isCurrentMonth(startDate, endDate) {
  const now = new Date();
  const start = parseDate(startDate);
  const end = parseDate(endDate);
  return (
    start.getMonth() === now.getMonth() &&
    end.getMonth() === now.getMonth() &&
    start.getFullYear() === now.getFullYear() &&
    end.getFullYear() === now.getFullYear()
  );
}
function isCurrentQuarter(startDate, endDate) {
  const now = new Date();
  const start = parseDate(startDate);
  const end = parseDate(endDate);
  const currentQuarter = Math.floor(now.getMonth() / 3);
  const startQuarter = Math.floor(start.getMonth() / 3);
  const endQuarter = Math.floor(end.getMonth() / 3);
  return (
    startQuarter === currentQuarter &&
    endQuarter === currentQuarter &&
    start.getFullYear() === now.getFullYear() &&
    end.getFullYear() === now.getFullYear()
  );
}

function findBalance(data, groupName, dataType, checkDateRange = null) {
  const detail = data.filter((obj) => {
    if (obj.AccountGroupName !== groupName) return false;
    if (dataType && obj.DataType === dataType) return true;
    if (checkDateRange && checkDateRange(obj.StartDate, obj.EndDate))
      return true;
    return false;
  });
  return detail.length > 0
    ? detail.reduce((acc, obj) => obj.GroupBalance + acc, 0)
    : 0;
}

function setDetails(state, data, groupName, id) {
  let FYAmount = findBalance(data, groupName, "Monthly");
  if (id === "netProfit") {
    if (FYAmount < 0) {
      state.cards[id].label = "Net Loss";
    } else {
      state.cards[id].label = "Net Profit";
    }
  }
  state.cards[id].value = FYAmount;
  state.cards[id].details.today.value = findBalance(data, groupName, "Today");
  state.cards[id].details.thisWeek.value = findBalance(
    data,
    groupName,
    "Weekly"
  );
  state.cards[id].details.thisMonth.value = findBalance(
    data,
    groupName,
    null,
    isCurrentMonth
  );
  state.cards[id].details.thisQuarter.value = findBalance(
    data,
    groupName,
    null,
    isCurrentQuarter
  );
}

const businessOverViewSlice = createSlice({
  name: "BusinessOverview",
  initialState: INITIAL_STATE,
  reducers: {
    resetBusinessOverViewState: () => ({ ...INITIAL_STATE }),
    setSelectCard: (state, action) => {
      state.selectedCard = action.payload;
    },
    setTopExpenses: (state, action) => {
      state["topExpenses"] = action.payload;
    },
    updateMainCardAmount: (state, action) => {
      const { id, amount } = action.payload;
      state.cards[id].value = amount;
    },
    updateDetailCardAmount: (state, action) => {
      const { id, key, key2, amount } = action.payload;
      console.log("action.payload");
      console.log(action.payload);
      state.cards[id][key][key2].value = amount;
    },
    setCurrentSelection: (state, action) => {
      const { key, value } = action.payload;
      state.currentSelection[key] = value;
    },
    setcompareOptions: (state, action) => {
      state.compareOptions = action.payload;
    },
    updateinitialData: (state, action) => {
      const { key, value } = action;
      state.initialData[key] = value;
    },
    setGraphData: (state, action) => {
      const { key, data, id } = action.payload;
      state.cards[id].compareGraphData[key] = data;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessOverviewData.fulfilled, (state, action) => {
        const { data, StartDate, EndDate, DataRange, type } = action.payload;
        if (DataRange === "" && type === "this") {
          setDetails(state, data, "Sales", "sales");
          setDetails(state, data, "Purchases", "purchases");
          setDetails(state, data, "Bank Accounts", "bank");
          setDetails(state, data, "Cash in Hand", "hand");
          setDetails(state, data, "Reserves and Surplus", "netProfit");
          state.initialData.this = data;
        } else if (DataRange === "MONTHLY" && type === "this") {
          state.monthlyData.data1 = data;
        } else if (DataRange === "MONTHLY" && type === "compare") {
          state.monthlyData.data2 = data;
        }
        if (DataRange === "" && type === "compare") {
          state.initialData.compare = data;
        }
        state.loading = false;
      })
      .addCase(fetchBusinessOverviewData.pending, (state, action) => {
        state.loading = true;
        // state.cards[action.meta.arg.id].render = false;
      })
      .addCase(fetchBusinessOverviewData.rejected, (state, action) => {
        state.loading = false;
        console.log(action);
        console.log("wokriinng error");
      })
      // .addCase(fetchNetProfit.fulfilled, (state, action) => {
      //   console.log("Fetchnetprofit");
      //   console.log(action);
      //   state.cards.netProfit.value = action.payload?.value;
      // })
      .addCase(PURGE, () => INITIAL_STATE);
  },
});

export const {
  resetBusinessOverViewState,
  setSelectCard,
  setTopExpenses,
  updateMainCardAmount,
  setCurrentSelection,
  setcompareOptions,
  setGraphData,
  resetGraph,
  setCardLoading,
  updateDetailCardAmount,
  updateinitialData,
} = businessOverViewSlice.actions;

export default businessOverViewSlice.reducer;
